import { documentNumberTranslations } from './document-number-i18n';
import { duplicationTranslations } from './duplication-i18n';
import { partnerMapTranslations } from './partner-map-i18n';
import { actionNeedTranslations } from './action-needs-i18n';
import { listViewTranslations } from './list-view-i18n';
import { pdfFieldCheckTranslations } from './pdf-field-check-i18n';
import { batchSelectionTranslations } from './batch-selection-i18n';
import { documentProgressTranslations } from './document-progress-i18n';
import { stockAdjustmentTranslations } from './stock-adjustment-i18n';
import { documentLockTranslations } from './document-lock-i18n';
import { portalRecoveryTranslations } from './portal-recovery-i18n';

import { priceGroupTranslations } from './price-group-i18n';
import { shippingTranslations } from '@erp/shared';
import { headerTranslations } from './header-i18n';
import { documentEntryTranslations } from './document-entry-i18n';
import { documentWorkspaceTranslations } from './document-workspace-i18n';
import { subdivisionTranslations } from './subdivision-i18n';
import { contactBriefingTranslations } from './contact-briefing-i18n';
import { internationalTranslations } from './international-i18n';
import { deliveryPlanningTranslations } from '@erp/shared';
import { introductionTranslations } from './introduction-i18n';
import { adminEs } from './admin-es';
import { analyticsEs } from './analytics-es';
import { dashboardEs } from './dashboard-i18n';
import { dmsEs } from './dms-es';
import { partnersEs } from './partners-es';
import { pdfDesignerEs } from './pdf-designer-es';
import { procurementEs } from './procurement-es';
import { questionnairesEs } from './questionnaires-es';
import { settingsHubEs } from './settings-hub-es';
import { telephonyEs } from './telephony-es';
import { whatsAppEs } from './whatsapp-es';
import { helpEs } from './help-es';
import { feedbackEs } from './feedback-es';
import { productSpecificationsEs } from './product-specifications-es';
import { plmEs } from './plm-es';
import { manufacturingEs } from './manufacturing-es';
import { traceabilityEs } from './traceability-es';
import { mrpEs } from './mrp-es';
import { labelsEs } from './labels-es';
import { changeControlEs } from './change-control-es';
import { productDevelopmentDashboardEs } from './product-development-dashboard-es';
import { searchEs } from './search-i18n';
import { vatValidationEs } from './vat-validation-i18n';
import { navigationEs } from './navigation-i18n';
import { dunningEs } from './dunning-i18n';
import { portalEs } from './portal-i18n';
import { productNewsEs } from './product-news-i18n';
import { newsletterEs } from './newsletter-i18n';
import { setupEs } from './setup-i18n';
import { importCenterEs } from './import-center-i18n';
import { bankingEs } from './banking-i18n';
import { translationGlossaryEs } from './translation-glossary-i18n';
import { salesAssistantEs } from './sales-assistant-i18n';
import { customerHeaderEs } from './customer-header-i18n';
import { featureAdminEs } from './feature-admin-i18n';

export const es = {
  translation: {
    documentNumber: documentNumberTranslations.es,
    duplication: duplicationTranslations.es,
    partnerMap: partnerMapTranslations.es,
    actionNeeds: actionNeedTranslations.es,
    listViews: listViewTranslations.es,
    pdfFieldCheck: pdfFieldCheckTranslations.es,
    stockAdjustment: stockAdjustmentTranslations.es,
    batchSelection: batchSelectionTranslations.es,
    documentProgress: documentProgressTranslations.es,
    documentLock: documentLockTranslations.es,
    portalRecovery: portalRecoveryTranslations.es,
    shipping: shippingTranslations.es,
    priceGroups: priceGroupTranslations.es,
    header: headerTranslations.es,
    documentEntry: documentEntryTranslations.es,
    documentWorkspace: documentWorkspaceTranslations.es,
    ...contactBriefingTranslations.es,
    international: internationalTranslations.es,
    subdivision: subdivisionTranslations.es,
    deliveryPlanning: deliveryPlanningTranslations.es,
    introduction: introductionTranslations.es,
    admin: { ...adminEs, dataHub: importCenterEs, features: featureAdminEs },
    analytics: analyticsEs,
    dms: dmsEs,
    portal: portalEs,
    productNews: productNewsEs,
    newsletter: newsletterEs,
    setup: setupEs,
    partners: partnersEs,
    pdfDesigner: pdfDesignerEs,
    procurement: procurementEs,
    questionnaires: questionnairesEs,
    settingsHub: settingsHubEs,
    telephony: telephonyEs,
    whatsapp: whatsAppEs,
    help: helpEs,
    feedback: feedbackEs,
    productSpecifications: productSpecificationsEs,
    plm: plmEs,
    manufacturing: manufacturingEs,
    traceability: traceabilityEs,
    mrp: mrpEs,
    labels: labelsEs,
    changeControl: changeControlEs,
    productDevelopmentDashboard: productDevelopmentDashboardEs,
    search: searchEs,
    vatValidation: vatValidationEs,
    dunning: dunningEs,
    banking: bankingEs,
    translationGlossary: translationGlossaryEs,
    paymentTerms: {
      netDays_one: '{{count}} día neto',
      netDays_other: '{{count}} días netos',
      discountPreview: '{{due}}, {{percent}} % de descuento en {{days}} días',
      customLegacy: 'Condición antigua individual',
      search: 'Buscar condiciones de pago…',
      noResults: 'No se encontraron condiciones de pago.',
      loadError: 'No se pudieron cargar las condiciones de pago.',
      warningCustom: 'Estos valores antiguos no están vinculados a una regla configurada.',
      warningInconsistent:
        'Los valores antiguos son contradictorios. Seleccione una condición válida.',
      advanced: 'Valores de pago individuales',
      customAgreement: 'Acuerdo individual',
      selectionHint:
        'El plazo de pago y el descuento por pronto pago se toman automáticamente de las condiciones seleccionadas.',
      customHint:
        'Estos valores individuales se aplican en lugar de las condiciones del catálogo. Una selección arriba los sustituye.',
      customize: 'Establecer condiciones individuales',
      inconsistentValues:
        'El plazo de descuento, el descuento y el vencimiento son incompatibles. Revise los valores o seleccione condiciones de pago.',
      savedValues: 'Condiciones guardadas · {{due}} · {{percent}} % de descuento en {{days}} días',
    },
    addressResolution: {
      automatic: 'Determinada automáticamente',
      adoptRegion: 'Usar la región propuesta {{region}}',
      importPlan: 'Regiones previstas en la prueba confirmada (se conservan los valores manuales)',
      status: {
        RESOLVED: 'Región determinada sin ambigüedad.',
        INCOMPLETE: 'Introduzca un código postal completo de cinco dígitos.',
        UNSUPPORTED: 'La asignación automática de región no está disponible para este país.',
        NO_MATCH:
          'No se encontró un municipio coincidente. Revise la dirección o introduzca la región manualmente.',
        CONFLICT:
          'La localidad y el código postal no coinciden. Corrija la dirección o seleccione un municipio.',
        AMBIGUOUS:
          'Los resultados pertenecen a distintas regiones. Seleccione el municipio correcto.',
        MISSING_REGION:
          'Los datos administrativos no contienen una región completa. Introdúzcala manualmente.',
        UNAVAILABLE:
          'La búsqueda de región no está disponible. Puede seguir guardando manualmente.',
      },
      backfill: {
        title: 'Completar regiones vacías de direcciones francesas existentes',
        hint: 'Vista previa de hasta 50 direcciones. Seleccione y confirme las asignaciones inequívocas. Se omiten registros modificados y regiones ya rellenadas. La vista previa caduca en 30 minutos.',
        partners: 'Comprobar direcciones principales',
        addresses: 'Comprobar otras direcciones',
        next: 'Comprobar el siguiente grupo',
        empty: 'No hay más direcciones francesas con región vacía.',
        select: 'Seleccionar {{label}} para completar',
        apply: 'Confirmar {{count}} asignaciones seleccionadas',
        result: '{{updated}} completadas; {{skipped}} modificadas o ya completadas.',
        error: 'El procesamiento falló. Genere una nueva vista previa y compruebe de nuevo.',
      },
      loading: 'Buscando ciudad y región…',
      errorFallback: 'La búsqueda no está disponible. Introduzca los datos manualmente.',
      noResults: 'No se encontró una localidad. Introdúzcala manualmente.',
      useSuggestion: 'Usar {{value}}',
      choose: 'Elegir localidad',
      chooseCount: 'Se encontraron {{count}} localidades — elija una',
      source: 'Fuente: {{source}}',
      help: 'Ayuda sobre la búsqueda de localidades',
    },
    salesAssistant: salesAssistantEs,
    customerHeader: customerHeaderEs,
    app: {
      name: 'ERP',
      tagline: 'ERP web modular',
    },
    nav: {
      ...navigationEs,
      label: 'Navegación principal',
      openMenu: 'Abrir menú',
      expandGroup: 'Expandir {{name}}',
      collapseGroup: 'Colapsar {{name}}',
      dashboard: 'Panel de control',
      partners: 'Socios comerciales',
      partnerCustomers: 'Clientes',
      partnerProspects: 'Prospectos / oportunidades',
      partnerSuppliers: 'Proveedores',
      partnerAll: 'Todos los contactos',
      products: 'Productos',
      productDevelopment: 'Desarrollo de producto',
      productDevelopmentOverview: 'Resumen',
      recipes: 'Recetas y listas de materiales',
      batchScaling: 'Escalado de lotes',
      declarations: 'Declaraciones',
      declarationCatalog: 'Datos maestros de declaración',
      analysisProfiles: 'Perfiles de análisis',
      analysisParameters: 'Parámetros de análisis',
      labels: 'Etiquetas',
      changeControl: 'Gestión de cambios',
      documents: 'Documentos',
      dms: 'Archivo de documentos',
      procurement: 'Compras',
      manufacturing: 'Producción',
      productionOrders: 'Órdenes de producción',
      traceability: 'Trazabilidad de lotes',
      mrp: 'Planificación de materiales',
      purchaseOrders: 'Órdenes de compra',
      goodsReceipts: 'Recepción de mercancías',
      vendorInvoices: 'Facturas de proveedores',
      analytics: 'Analítica',
      analyticsOverview: 'Análisis general',
      employeePerformance: 'Rendimiento del empleado',
      datev: 'Exportación DATEV',
      intrastat: 'Intrastat',
      settings: 'Configuración',
      profile: 'Mi perfil',
      security: 'Seguridad',
      notifications: 'Notificaciones',
      company: 'Empresa',
      pdfDesigner: 'Plantillas PDF',
      users: 'Usuarios',
      roles: 'Roles y permisos',
      securityLog: 'Registro de seguridad',
      admin: 'Administración',
      whatsapp: 'WhatsApp',
      whatsappConfig: 'Configuración de WhatsApp',
      field: 'Servicio de campo',
      questionnaireTemplates: 'Cuestionarios',
      questionnaireResults: 'Resultados del cuestionario',
    },
    console: {
      label: 'Administración',
      breadcrumb: 'Ruta de navegación',
      openMenu: 'Abrir menú de administración',
      backToApp: 'Volver a la vista principal',
      groups: {
        overview: 'Sistema y descripción general',
        access: 'Acceso y seguridad',
        configuration: 'Configuración',
        communication: 'Comunicación',
      },
      items: {
        accounting: 'Plan de cuentas DATEV',
        questionnaireTemplates: 'Plantillas de cuestionarios',
        questionnaireResults: 'Resultados del cuestionario',
        questionnaireSettings: 'Configuración de cuestionarios',
      },
    },
    theme: {
      label: 'Apariencia',
      light: 'Claro',
      dark: 'Oscuro',
      system: 'Sistema',
    },
    language: {
      label: 'Idioma',
      search: 'Buscar idioma',
      noResults: 'No se encontró ningún idioma.',
      saveError: 'No se pudo guardar el idioma.',
      tr: 'Turco',
      fr: 'Francés',
      es: 'Español',
      de: 'Alemán',
      en: 'Inglés',
    },
    dashboard: {
      title: 'Panel de control',
      ...dashboardEs,
    },
    errorPage: {
      title: 'Error inesperado',
      description: 'No se pudo cargar esta vista.',
      reload: 'Recargar página',
    },
    systemStatus: {
      title: 'Estado del sistema',
      description: 'Comprobación de disponibilidad en vivo de la API.',
      loading: 'Cargando estado …',
      error: 'No se pudo cargar el estado del sistema.',
      retry: 'Intentar de nuevo',
      api: 'API',
      database: 'Base de datos',
      version: 'Versión',
      uptime: 'Tiempo de actividad',
      state: {
        ok: 'Operativo',
        degraded: 'Degradado',
        up: 'Conectado',
        down: 'Desconectado',
      },
      uptimeValue: '{{minutes}} min',
    },
    common: {
      loading: 'Cargando …',
      create: 'Crear',
      saving: 'Guardando…',
      save: 'Guardar',
      confirm: 'Confirmar',
      select: 'Por favor seleccione',
      error: 'Se ha producido un error inesperado.',
      cancel: 'Cancelar',
      back: 'Atrás',
      delete: 'Eliminar',
      edit: 'Editar',
      close: 'Cerrar',
      retry: 'Reintentar',
      previous: 'Anterior',
      next: 'Siguiente',
      none: 'Ninguno',
      pleaseSelect: 'Por favor seleccione',
      pagination: 'Paginación',
      paginationInfo: 'Página {{page}} de {{totalPages}} · {{total}} registros',
      copy: 'Copiar',
      copied: 'Copiado',
      actions: 'Acciones',
      showDetails: 'Mostrar detalles',
      hideDetails: 'Ocultar detalles',
    },
    validation: {
      required: 'Requerido',
      email: 'Por favor proporcione una dirección de correo electrónico válida.',
    },
    errors: {
      requestFailed: 'La solicitud falló',
      unexpectedTitle: 'Error inesperado',
      unexpectedMessage: 'Ocurrió un error inesperado.',
      copyHint: '(haga clic para copiar)',
      copyId: 'Copiar ID',
      copied: 'ID de error {{id}} copiado.',
    },
    documentPricing: {
      overrideRequired: 'Este rol no puede modificar precios ni condiciones financieras.',
    },
    permissions: {
      customerPricingReadOnly:
        'Los grupos de precios, descuentos y condiciones de pronto pago son de solo lectura para este rol.',
      deniedTitle: 'Sin acceso',
      deniedDescription: 'Esta vista requiere el permiso {{permission}}.',
    },
    auth: {
      title: 'Iniciar sesión',
      subtitle: 'Inicie sesión con sus credenciales.',
      email: 'Correo electrónico',
      password: 'Contraseña',
      tenantSlug: 'Organización',
      tenantSlugHint: 'Nombre corto de la organización, por ejemplo, acme.',
      submit: 'Iniciar sesión',
      logout: 'Cerrar sesión',
      checking: 'Comprobando sesión …',
      invalidCredentials: 'El correo electrónico o la contraseña son incorrectos.',
      accountLocked:
        'La cuenta está temporalmente bloqueada. Por favor, inténtalo de nuevo más tarde.',
      tenantRequired:
        'Este correo electrónico existe en varias organizaciones. Indique la organización.',
      twoFactor: {
        title: 'Verificación en dos pasos',
        description: 'Ingresa el código de seis dígitos de tu aplicación de autenticación.',
        emailDescription: 'Ingresa el código de seis dígitos enviado a {{email}}.',
        useMethod: {
          TOTP: 'Usar aplicación de autenticación',
          EMAIL: 'Usar código por correo electrónico',
        },
        resend: 'Reenviar código',
        resendIn: 'Reenviar en {{seconds}} s',
        backupDescription: 'Ingresa uno de tus códigos de respaldo.',
        code: 'Código de verificación',
        backupCode: 'Código de respaldo',
        submit: 'Verificar',
        invalid: 'El código es inválido o ha caducado.',
        useBackupCode: 'Usar un código de respaldo',
        useAuthenticator: 'Usar la aplicación de autenticación',
      },
    },
    customFields: {
      createTitle: 'Crear campo personalizado',
      editTitle: 'Editar campo personalizado',
      dialogDescription:
        'Los campos personalizados amplían los datos del cliente sin cambios de código. La clave y el tipo de campo se fijan después de la creación.',
      key: 'Clave',
      keyHint: 'Nombre técnico, p. ej. grupoCliente.',
      type: 'Tipo de campo',
      label: 'Etiqueta',
      labelEn: 'Etiqueta (Inglés)',
      group: 'Grupo',
      sortOrder: 'Orden de clasificación',
      required: 'Requerido',
      showInList: 'Mostrar en la lista',
      filterable: 'Filtrable',
      marketingSegmentationAllowed: 'Aprobado para segmentación de boletines',
      options: 'Opciones',
      addOption: 'Agregar opción',
      removeOption: 'Eliminar opción',
      noOptions: 'Aún no se han definido opciones.',
      optionValue: 'Valor',
      optionLabel: 'Etiqueta',
      created: 'Campo personalizado creado.',
      updated: 'Campo personalizado actualizado.',
      archived: 'Campo personalizado archivado.',
      archive: 'Archivar',
      archiveTitle: 'Archivar campo personalizado',
      archiveDescription: 'El campo "{{name}}" será oculto. Los valores existentes se conservan.',
      saveError: 'No se pudo guardar el campo personalizado.',
      loadError: 'No se pudieron cargar los campos personalizados.',
      filters: {
        action: 'Campos personalizados',
        title: 'Filtrar por campos personalizados',
        description: 'Los campos de texto buscan contenido; los demás usan un valor exacto.',
        reset: 'Restablecer',
        clearField: 'Quitar el filtro de {{field}}',
      },
      weeklySchedule: {
        empty: 'No hay franjas horarias registradas.',
        hint: 'Seleccione los días y las horas locales. Puede añadir varias franjas. La hora de fin debe ser posterior a la de inicio del mismo día.',
        invalid: 'Indique al menos un día y horas de inicio y fin válidas.',
        required: 'Se requiere al menos una franja horaria completa.',
      },
      types: {
        WEEKLY_SCHEDULE: 'Días de la semana y horarios',
        TEXT: 'Texto',
        TEXTAREA: 'Texto multilínea',
        NUMBER: 'Número',
        DATE: 'Fecha',
        CHECKBOX: 'Casilla de verificación',
        SELECT: 'Seleccionar',
        MULTI_SELECT: 'Selección múltiple',
      },
    },
    customers: {
      title: 'Clientes',
      subtitle: 'Datos maestros, términos e historial de contacto de todos los clientes.',
      searchPlaceholder: 'Buscar por nombre, número, ciudad, NIF ...',
      searchLabel: 'Buscar clientes',
      columnsMenu: 'Columnas',
      createTitle: 'Nuevo cliente',
      editTitle: 'Editar cliente',
      formDescription:
        'Los campos obligatorios están marcados. El número de cliente se asigna automáticamente.',
      created: 'Cliente creado.',
      updated: 'Cliente guardado.',
      saveError: 'No se pudo guardar el cliente.',
      actions: {
        create: 'Nuevo cliente',
        export: 'Exportar',
        logCall: 'Registrar llamada',
        createQuote: 'Crear cotización',
        backToList: 'Volver a la lista',
      },
      tabs: {
        master: 'Datos maestros y direcciones',
        customFields: 'Campos personalizados',
        history: 'Historial',
        documents: 'Documentos',
        whatsapp: 'WhatsApp',
      },
      sections: {
        masterData: 'Datos maestros',
        address: 'Dirección',
        tax: 'Impuestos e identificación',
        conditions: 'Condiciones de pago',
        customFields: 'Campos personalizados',
      },
      detail: {
        since: 'Creado el {{date}}',
      },
      values: {
        days_one: '{{count}} día',
        days_other: '{{count}} días',
      },
      columns: {
        customerNumber: 'Número',
        displayName: 'Nombre',
        status: 'Estado',
        industry: 'Industria',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        city: 'Ciudad',
        countryCode: 'País',
        vatId: 'ID de IVA',
        ownerName: 'Propietario',
        tags: 'Etiquetas',
      },
      fields: {
        type: 'Tipo de cliente',
        status: 'Estado',
        customerNumber: 'Número de cliente',
        customerNumberHint: 'Dejar vacío para asignación automática.',
        industry: 'Industria',
        companyName: 'Nombre de la empresa',
        firstName: 'Nombre',
        lastName: 'Apellido',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        website: 'Sitio web',
        street: 'Calle',
        houseNumber: 'Número de casa',
        addressLine2: 'Dirección 2',
        postalCode: 'Código postal',
        city: 'Ciudad',
        region: 'Región',
        countryCode: 'País',
        vatId: 'ID de IVA',
        vatIdHint: 'El formato se valida, por ejemplo, DE123456789.',
        vatIdStatus: 'Estado de NIF',
        taxNumber: 'Número de impuesto',
        taxCategory: 'Categoría de impuesto',
        datevDebtorAccount: 'Cuenta de deudor DATEV',
        gln: 'GLN',
        eoriNumber: 'Número de identificación fiscal EORI',
        currency: 'Moneda',
        documentLanguage: 'Idioma del documento',
        paymentTermsDays: 'Términos de pago (días)',
        defaultDiscountPct: 'Descuento',
        cashDiscountPct: 'Descuento en efectivo',
        cashDiscountDays: 'Período de descuento en efectivo (días)',
        deliveryTerms: 'Términos de entrega',
        creditLimit: 'Límite de crédito',
        priceGroup: 'Grupo de precios',
        minRemainingShelfLifeDays: 'Vida útil mínima restante (días)',
        deliveryBlock: 'Bloqueo de entrega',
        dunningBlock: 'Bloqueo de recordatorio de pago',
        ownerName: 'Propietario',
        tags: 'Etiquetas',
        tagsHint: 'Separe múltiples valores con comas.',
      },
      types: {
        COMPANY: 'Empresa',
        PERSON: 'Persona privada',
      },
      statuses: {
        ACTIVE: 'Activo',
        PROSPECT: 'Prospecto',
        BLOCKED: 'Bloqueado',
        INACTIVE: 'Inactivo',
      },
      vatIdStatuses: {
        UNCHECKED: 'Sin comprobar',
        VALID: 'Válido',
        INVALID: 'Inválido',
        NOT_CHECKABLE: 'No comprobable',
        SERVICE_UNAVAILABLE: 'Servicio no disponible',
      },
      taxCategories: {
        DOMESTIC: 'Nacional',
        EU_B2B: 'UE B2B',
        EU_B2C: 'UE B2C',
        THIRD_COUNTRY: 'Tercer país',
        REVERSE_CHARGE_DOMESTIC: 'Inversión del sujeto pasivo (doméstico)',
        TAX_EXEMPT: 'Exento de impuestos',
      },
      industries: {
        RETAIL: 'Venta al por menor',
        WHOLESALE: 'Venta al por mayor',
        MANUFACTURING: 'Fabricación',
        GASTRONOMY: 'Gastronomía',
        LOGISTICS: 'Logística',
        HEALTHCARE: 'Salud',
        PUBLIC_SECTOR: 'Sector público',
        CONSTRUCTION: 'Construcción',
        AGRICULTURE: 'Agricultura',
        SERVICES: 'Servicios',
        OTHER: 'Otros',
      },
      documentTypes: {
        QUOTE: 'Cotización',
        ORDER: 'Pedido',
        DELIVERY_NOTE: 'Nota de entrega',
        INVOICE: 'Factura',
        CREDIT_NOTE: 'Nota de crédito',
        CANCELLATION: 'Cancelación',
      },
      documentStatuses: {
        DRAFT: 'Borrador',
        OPEN: 'Abierto',
        CONFIRMED: 'Confirmado',
        PARTIALLY_DELIVERED: 'Parcialmente entregado',
        DELIVERED: 'Entregado',
        POSTED: 'Publicado',
        PAID: 'Pagado',
        CANCELLED: 'Cancelado',
      },
      filters: {
        status: 'Estado',
        industry: 'Industria',
        tags: 'Etiquetas',
        vatIdStatus: 'ID de IVA',
        reset: 'Restablecer filtros',
      },
      states: {
        empty: 'Aún no hay clientes.',
        emptyFiltered: 'Ningún cliente coincide con la selección actual.',
        error: 'No se pudo cargar la lista de clientes.',
        detailError: 'No se pudo cargar el cliente.',
      },
      export: {
        csv: 'Descargar CSV',
        xlsx: 'Descargar Excel',
        success: 'Exportación creada.',
        error: 'Falló la exportación.',
      },
      delete: {
        title: 'Eliminar cliente',
        description: 'El cliente "{{name}}" será desactivado y oculto.',
        success: 'Cliente eliminado.',
        error: 'No se pudo eliminar el cliente.',
      },
      addresses: {
        title: 'Direcciones adicionales',
        add: 'Dirección',
        createTitle: 'Agregar dirección',
        editTitle: 'Editar dirección',
        description: 'Direcciones de envío y facturación diferentes de la dirección principal.',
        type: 'Tipo de dirección',
        label: 'Etiqueta',
        recipient: 'Destinatario',
        isDefault: 'Predeterminado',
        contact: {
          title: 'Contacto de esta dirección',
          hint: 'Datos opcionales exclusivos de esta dirección. No se crea un contacto general.',
          name: 'Nombre',
          position: 'Cargo / función',
          phone: 'Teléfono',
          mobile: 'Móvil',
          email: 'Correo electrónico',
          invalidEmail: 'Introduzca una dirección de correo electrónico válida.',
        },
        deliveryTermsOverride: 'Anular condiciones de entrega',
        individualDeliveryTerms: 'Condiciones de entrega individuales',
        inheritedDeliveryTerms: 'Predeterminado del cliente: {{value}}',
        deliveryTermsHint:
          'Sin una anulación, se utilizan automáticamente las condiciones de entrega de los datos maestros del cliente.',
        confirmRemoveDeliveryTerms:
          'Cambiar el tipo de dirección elimina sus condiciones de entrega individuales. ¿Continuar?',
        empty: 'No hay direcciones adicionales.',
        created: 'Dirección guardada.',
        updated: 'Dirección actualizada.',
        deleted: 'Dirección eliminada.',
        delete: 'Eliminar dirección',
        deleteTitle: 'Eliminar dirección',
        deleteDescription: 'La dirección será eliminada del registro del cliente.',
        error: 'No se pudo guardar la dirección.',
        loadError: 'No se pudieron cargar las direcciones.',
        types: {
          BILLING: 'Dirección de facturación',
          SHIPPING: 'Dirección de envío',
          OTHER: 'Otros',
        },
      },
      contacts: {
        title: 'Contactos',
        add: 'Contacto',
        createTitle: 'Agregar contacto',
        editTitle: 'Editar contacto',
        description: 'Personas de contacto para cotizaciones, pedidos y llamadas.',
        salutation: 'Saludo',
        title_label: 'Título',
        position: 'Puesto',
        department: 'Departamento',
        mobile: 'Móvil',
        isPrimary: 'Contacto principal',
        responsibilities: 'Responsabilidades',
        responsibilitiesHint: 'Separe varias responsabilidades con comas.',
        optOutMarketing: 'Excluir de las comunicaciones de marketing',
        empty: 'Aún no hay contactos.',
        created: 'Contacto guardado.',
        updated: 'Contacto actualizado.',
        deleted: 'Contacto eliminado.',
        delete: 'Eliminar contacto',
        deleteTitle: 'Eliminar contacto',
        deleteDescription: 'El contacto será eliminado del registro del cliente.',
        error: 'No se pudo guardar el contacto.',
        loadError: 'No se pudieron cargar los contactos.',
      },
      notes: {
        add: 'Agregar nota',
        subject: 'Asunto',
        body: 'Nota',
        created: 'Nota guardada.',
        error: 'No se pudo guardar la nota.',
      },
      calls: {
        createTitle: 'Registrar llamada',
        description: 'Documentar resultado, duración y seguimiento de la llamada.',
        direction: 'Dirección',
        outcome: 'Resultado',
        subject: 'Asunto',
        contact: 'Contacto',
        occurredAt: 'Hora',
        durationSeconds: 'Duración (segundos)',
        notes: 'Notas de la llamada',
        created: 'Llamada guardada.',
        error: 'No se pudo guardar la llamada.',
        directions: {
          INBOUND: 'Entrante',
          OUTBOUND: 'Saliente',
        },
        outcomes: {
          REACHED: 'Contactado',
          NOT_REACHED: 'No contactado',
          CALLBACK: 'Devolución de llamada acordada',
          ORDER_PLACED: 'Orden realizada',
          COMPLAINT: 'Queja',
          NO_INTEREST: 'Sin interés',
        },
      },
      quotes: {
        createTitle: 'Crear cotización',
        description: 'Crea un presupuesto borrador usando los términos de este cliente.',
        reference: 'Referencia',
        validDays: 'Validez (días)',
        submit: 'Crear cotización',
        created: 'Presupuesto creado.',
        error: 'No se pudo crear el presupuesto.',
      },
      documents: {
        empty: 'Aún no hay documentos.',
        error: 'No se pudieron cargar los documentos.',
      },
      activities: {
        empty: 'Aún no hay actividades.',
        error: 'No se pudo cargar el historial.',
        types: {
          DOCUMENT: 'Documentos',
          NOTE: 'Notas',
          CALL: 'Llamadas',
        },
      },
      customFields: {
        title: 'Campos personalizados dinámicos',
        subtitle: 'Los campos se configuran aquí mismo y están disponibles de inmediato.',
        empty: 'Aún no se han definido campos personalizados.',
        saved: 'Campos personalizados guardados.',
      },
    },
    inventory: {
      expiringWidget: {
        title: 'Advertencias de vencimiento',
        description: 'Lotes con una vida útil restante de {{days}} días o menos.',
        empty: 'Ningún lote está próximo a vencer.',
        error: 'No se pudieron cargar las advertencias de vencimiento.',
        entry: 'Lote {{batch}} · {{quantity}} · ubicación {{location}}',
        open: 'Abierto',
        openBatch: 'Abrir lote {{batch}} en el producto',
        openProducts: 'Ir a productos',
        showAll: 'Mostrar todos los productos afectados',
      },
    },
    products: {
      title: 'Productos',
      subtitle: 'Datos maestros, precios, envases y stock de lote.',
      searchPlaceholder: 'Número de artículo, nombre o GTIN …',
      searchLabel: 'Buscar productos',
      createTitle: 'Crear producto',
      editTitle: 'Editar producto',
      formDescription: 'Todos los valores se aplican al inquilino actual.',
      created: 'Producto creado.',
      updated: 'Producto guardado.',
      saveError: 'No se pudo guardar el producto.',
      columnsMenu: 'Columnas',
      decimals: {
        hint: 'Use punto o coma decimal: 47,45 y 47.45 son iguales. 47, o 47. se guarda como 47. No introduzca separadores de miles.',
        moneyError:
          'Introduzca un número válido con un máximo de 4 decimales; se permite punto o coma.',
        percentError:
          'Introduzca un valor de 0 a 100 con un máximo de 6 decimales; se permite punto o coma.',
        quantityError:
          'Introduzca un número no negativo con un máximo de 6 decimales; se permite punto o coma.',
      },
      texts: {
        translatedName: 'Nombre ({{language}})',
        translatedDescription: 'Descripción ({{language}})',
        languageLabel: 'Idioma de los textos del artículo',
        optionalHint:
          'Las traducciones son opcionales. Se usan los textos alemanes cuando falta una traducción.',
        validationSummary: 'Revise los campos señalados. Sus datos se conservan.',
        nameRequired: 'Introduzca el nombre en alemán.',
        nameTooLong: 'El nombre no puede superar los 200 caracteres.',
        descriptionTooLong: 'La descripción no puede superar los 4000 caracteres.',
      },
      tabs: {
        master: 'Datos maestros y precios',
        images: 'Imágenes',
        priceTiers: 'Escalas de precios',
        specifications: 'Especificaciones',
        packagings: 'Envases',
        batches: 'Lotes y caducidad',
        movements: 'Historial de stock',
      },
      detail: {
        stockSummary: 'Stock {{stock}} {{unit}} · disponible {{available}} {{unit}}',
      },
      badges: {
        batchManaged: 'Gestión por lotes',
        belowMinStock: 'Por debajo del stock mínimo',
      },
      actions: {
        create: 'Crear producto',
        export: 'Exportar',
        bulkPrice_one: 'Actualizar precios ({{count}})',
        bulkPrice_other: 'Actualizar precios ({{count}})',
        adjustStock: 'Ajustar stock',
        backToList: 'Volver a la lista',
      },
      export: {
        csv: 'Descargar CSV',
        xlsx: 'Descargar Excel',
        success: 'Exportación creada.',
        error: 'Falló la exportación.',
      },
      states: {
        empty: 'Aún no hay productos.',
        emptyFiltered: 'Ningún producto coincide con los filtros actuales.',
        error: 'No se pudieron cargar los productos.',
        detailError: 'No se pudo cargar el producto.',
      },
      selection: {
        toggleAll: 'Seleccionar todos los productos en esta página',
        toggleRow: 'Seleccionar {{name}}',
      },
      columns: {
        icon: 'Tipo',
        image: 'Imagen',
        articleNumber: 'Nº de artículo',
        name: 'Nombre',
        productGroup: 'Grupo de productos',
        productGroupLegacy: 'Grupo de productos (campo de compatibilidad)',
        stock: 'Stock',
        available: 'Disponible',
        listPrice: 'Precio de lista',
        purchasePrice: 'Costo',
        batches: 'Lotes',
        status: 'Estado',
        tags: 'Etiquetas',
      },
      batchBadge: {
        count_one: '{{count}} lote',
        count_other: '{{count}} lotes',
        expiring_one: '{{count}} advertencia de caducidad',
        expiring_other: '{{count}} advertencias de caducidad',
      },
      filters: {
        criticalStock: 'Stock crítico',
        expiring: 'Advertencias de caducidad (< {{days}} días)',
        activeOnly: 'Solo productos activos',
        status: 'Estado',
        type: 'Tipo de producto',
        productGroup: 'Grupo de productos',
        batchManaged: 'Seguimiento de lote',
        batchManagedOnly: 'Solo gestionado por lote',
        batchManagedNone: 'Sin seguimiento de lote',
        reset: 'Restablecer filtros',
      },
      sections: {
        base: 'Datos maestros',
        prices: 'Precios y planificación',
        logistics: 'Logística y aduanas',
        batches: 'Lotes y caducidad',
        customFields: 'Campos personalizados',
      },
      fields: {
        articleNumber: 'Número de artículo',
        articleNumberHint: 'Dejar vacío para sacar el siguiente número del rango.',
        name: 'Nombre',
        nameEn: 'Nombre (EN)',
        description: 'Descripción',
        type: 'Tipo de producto',
        status: 'Estado',
        ean: 'GTIN/EAN',
        manufacturerNumber: 'Número de fabricante',
        productGroup: 'Grupo de productos',
        baseUnit: 'Unidad base',
        taxRateType: 'Tasa impositiva',
        taxRatePct: 'Tasa impositiva (%)',
        currency: 'Moneda',
        listPrice: 'Precio de venta',
        purchasePrice: 'Precio de compra',
        minMarginPct: 'Margen mínimo (%)',
        marginHint: 'Margen actual: {{value}}',
        weightNetKg: 'Peso neto (kg)',
        weightGrossKg: 'Peso bruto (kg)',
        commodityCode: 'Código de mercancía',
        commodityCodeHint: 'Número de tarifa aduanera con 8, 10 u 11 dígitos.',
        countryOfOrigin: 'País de origen',
        minStock: 'Stock mínimo',
        reorderPoint: 'Punto de reorden',
        targetStock: 'Stock objetivo',
        leadTimeDays: 'Tiempo de entrega (días)',
        isBatchManaged: 'Gestión por lotes',
        isShelfLifeManaged: 'Vida útil gestionada',
        shelfLifeDays: 'Vida útil (días)',
        shelfLifeDaysHint:
          'Se utiliza para rellenar previamente la fecha de caducidad de los nuevos lotes.',
        minRemainingShelfLifeDays: 'Vida útil mínima restante (días)',
        pickingStrategy: 'Estrategia de picking',
        tags: 'Etiquetas',
        tagsHint: 'Separe múltiples valores con comas.',
      },
      statuses: {
        ARCHIVED: 'Archivado',
        ACTIVE: 'Activo',
        PHASE_OUT: 'Eliminación gradual',
        DISCONTINUED: 'Descontinuado',
        BLOCKED: 'Bloqueado',
      },
      types: {
        STOCK: 'Artículo en stock',
        NON_STOCK: 'Artículo fuera de stock',
        SERVICE: 'Servicio',
        SET: 'Lista de materiales',
        DEPOSIT: 'Depósito',
      },
      taxRateTypes: {
        STANDARD: 'Tarifa estándar',
        REDUCED: 'Tarifa reducida',
        ZERO: 'Tarifa cero',
      },
      pickingStrategies: {
        FEFO: 'FEFO (primero que vence, primero en salir)',
        FIFO: 'FIFO (primero en entrar, primero en salir)',
        MANUAL: 'Selección manual',
      },
      images: {
        title: 'Imágenes del producto',
        gallery: 'Galería de imágenes',
        empty: 'Todavía no se han agregado imágenes a este producto.',
        loadError: 'No se pudieron cargar las imágenes del producto.',
        drop: 'Suelte imágenes aquí o seleccione archivos',
        detected: 'Se detectó(n) archivo(s) {{count}}',
        remaining: 'Quedan ranura(s) de imagen {{count}} · JPEG, PNG, WebP o AVIF',
        choose: 'Elegir archivos',
        camera: 'Usar cámara',
        invalidSelection:
          'Al menos un archivo no es válido o se superaría el número máximo de imágenes.',
        removePending: 'Quitar {{name}} de la selección',
        partialUploadError:
          'No se pudieron subir {{count}} imagen(es). El producto se guardó; intente subir solo estos archivos.',
        limits: 'JPEG, PNG, WebP o AVIF · máximo 20 MB · hasta {{count}} imágenes',
        count: '{{current}} de {{max}} imágenes',
        progress: 'Cargando: {{progress}}%',
        uploadStates: {
          PENDING: 'Esperando',
          UPLOADING: 'Subiendo: {{progress}}%',
          SUCCESS: 'Subido',
          FAILED: 'Error — reintente al guardar',
        },
        uploaded: '{{count}} imagen(es) subidas.',
        uploadError: 'No se pudieron subir las imágenes.',
        emptyFile: 'El archivo está vacío.',
        fileTooLarge: 'El archivo supera los 20 MB.',
        unsupportedFormat: 'Solo se soportan JPEG, PNG, WebP y AVIF.',
        tooMany: 'Un producto puede tener como máximo {{count}} imágenes.',
        selection: 'Selección',
        select: 'Seleccionar {{title}}',
        primary: 'Imagen principal',
        makePrimary: 'Hacer imagen principal',
        primarySet: 'Imagen principal cambiada.',
        fullscreen: 'Pantalla completa',
        original: 'Ver original',
        replace: 'Reemplazar imagen',
        replaced: 'Imagen reemplazada.',
        deleteTitle: '¿Eliminar imagen del producto?',
        deleteDescription:
          '"{{name}}" y sus variantes originales y de presentación se eliminarán permanentemente.',
        deleted: 'Imagen eliminada.',
        deleteError: 'No se pudo eliminar la imagen.',
        sorted: 'Orden de las imágenes guardado.',
        sortError: 'No se pudo guardar el orden de las imágenes.',
        editTitle: 'Editar detalles de la imagen',
        editDescription: 'El título y el texto alternativo permiten una presentación accesible.',
        imageTitle: 'Título de la imagen',
        altText: 'Texto alternativo',
        altHint: 'Describa brevemente y de manera objetiva el contenido visible de la imagen.',
        updated: 'Detalles de la imagen guardados.',
        updateError: 'No se pudo actualizar la imagen.',
        retrySuccess: 'Variantes de la imagen regeneradas.',
      },
      categories: {
        action: 'Administrar categorías',
        title: 'Categorías de productos',
        description:
          'Estructurar categorías específicas del inquilino jerárquicamente y asignar productos.',
        tree: 'Árbol de categorías',
        editor: 'Editar categoría',
        search: 'Buscar categorías …',
        showInactive: 'Mostrar categorías inactivas',
        empty: 'Aún no hay categorías que coincidan.',
        loadError: 'No se pudieron cargar las categorías.',
        createRoot: 'Crear categoría raíz',
        createChild: 'Crear subcategoría debajo de {{name}}',
        createTitle: 'Crear categoría',
        editTitle: 'Editar categoría',
        expand: 'Expandir {{name}}',
        collapse: 'Colapsar {{name}}',
        productCount: 'Productos de {{count}}',
        inactive: 'Inactivo',
        active: 'Activo',
        name: 'Nombre',
        nameEn: 'Nombre (Inglés)',
        categoryDescription: 'Descripción',
        parent: 'Categoría padre',
        root: 'Nivel superior',
        sortOrder: 'Orden de clasificación',
        archive: 'Archivar',
        archiveTitle: '¿Archivar categoría de producto?',
        archiveDescription:
          '“{{name}}” será desactivado y eliminado de la navegación de categoría activa.',
        archived: 'Categoría archivada.',
        archiveError: 'No se pudo archivar la categoría.',
        created: 'Categoría creada.',
        updated: 'Categoría guardada.',
        saveError: 'No se pudo guardar la categoría.',
        assignments: 'Categorías',
        selected: 'Categoría/categorías {{count}} seleccionada/s',
        primary: 'Categoría principal',
        makePrimary: 'Hacer de {{name}} la categoría principal',
      },
      batchStatuses: {
        FREE: 'Libre',
        QUARANTINE: 'Cuarentena',
        BLOCKED: 'Bloqueado',
        EXPIRED: 'Expirado',
        DEPLETED: 'Agotado',
      },
      movementTypes: {
        GOODS_RECEIPT: 'Recepción de bienes',
        GOODS_ISSUE: 'Salida de bienes',
        TRANSFER_IN: 'Transferencia entrante',
        TRANSFER_OUT: 'Transferencia saliente',
        ADJUSTMENT: 'Ajuste',
        INVENTORY_COUNT: 'Conteo de inventario',
        SCRAP: 'Chatarra',
        RETURN_IN: 'Devolución de cliente',
        RETURN_OUT: 'Devolución de proveedor',
      },
      referenceTypes: {
        MANUAL: 'Manual',
        ORDER: 'Pedido',
        DELIVERY_NOTE: 'Nota de entrega',
        INVOICE: 'Factura',
        PURCHASE_ORDER: 'Orden de compra',
        INVENTORY: 'Inventario',
        PRODUCTION: 'Producción',
      },
      units: {
        PCE: 'unidades',
        KGM: 'kg',
        GRM: 'g',
        LTR: 'l',
        MLT: 'ml',
        MTR: 'm',
        MTQ: 'm³',
        MTK: 'm²',
        PA: 'paquete',
      },
      packagingUnits: {
        BX: 'Caja',
        CT: 'Cartón',
        PF: 'Palé',
        PK: 'Paquete',
        TU: 'Bandeja',
        BG: 'Bolsa',
        CS: 'Estuche',
      },
      priceTiers: {
        add: 'Añadir nivel',
        remove: 'Eliminar nivel',
        empty: 'No se han definido niveles de precios todavía.',
        saved: 'Niveles de precios guardados.',
        saveError: 'No se pudieron guardar los niveles de precios.',
        calculate: 'Aplicar descuento',
        calculatorHint: 'El descuento se aplica al precio de lista.',
        columns: {
          priceGroup: 'Grupo de precios',
          minQuantity: 'Desde cantidad',
          unitPrice: 'Precio unitario',
          discountPct: 'Descuento (%)',
          margin: 'Margen',
          validFrom: 'Válido desde',
          validTo: 'Válido hasta',
        },
      },
      packagings: {
        add: 'Añadir embalaje',
        remove: 'Eliminar embalaje',
        empty: 'No se han definido embalajes todavía.',
        description: 'El factor de conversión describe la cantidad en {{unit}} por embalaje.',
        saved: 'Envases guardados.',
        saveError: 'No se pudieron guardar los envases.',
        fields: {
          code: 'Código',
          name: 'Nombre',
          unitCode: 'Tipo de envase',
          factor: 'Factor de conversión',
          factorHint: 'Cantidad en {{unit}} por envase.',
          ean: 'GTIN del envase',
          weightGrossKg: 'Peso bruto (kg)',
          lengthMm: 'Largo (mm)',
          widthMm: 'Ancho (mm)',
          heightMm: 'Alto (mm)',
          minOrderQuantity: 'Cantidad mínima de pedido',
          orderStepQuantity: 'Incremento de pedido',
          isSalesDefault: 'Predeterminado de ventas',
          isPurchaseDefault: 'Predeterminado de compras',
        },
      },
      batches: {
        create: 'Añadir lote',
        empty: 'Aún no hay lotes.',
        error: 'No se pudieron cargar los lotes.',
        notManaged: 'Este producto no se gestiona por lote.',
        includeDepleted: 'Mostrar lotes agotados',
        totalRemaining: 'Stock total {{value}} {{unit}}',
        daysLeft_one: '{{count}} día restante',
        daysLeft_other: '{{count}} días restantes',
        block: 'Bloquear',
        release: 'Liberar',
        blocked: 'Lote {{batch}} bloqueado.',
        released: 'Lote {{batch}} liberado.',
        blockTitle: 'Bloquear lote',
        blockDescription: 'El lote {{batch}} será bloqueado por problemas.',
        blockReason: 'Razón',
        releaseReason: 'Liberado después de la inspección',
        updateError: 'No se pudo actualizar el lote.',
        customFieldsEditTitle: 'Editar campos personalizados del lote',
        customFieldsEditDescription: 'Datos adicionales del lote {{batch}}.',
        customFieldsSaved: 'Campos personalizados del lote guardados.',
        levels: {
          EXPIRED: 'Expirado',
          CRITICAL: 'Crítico',
          WARNING: 'Advertencia',
          OK: 'No crítico',
        },
        columns: {
          batchNumber: 'Lote',
          bestBeforeDate: 'Fecha de caducidad',
          remainingShelfLife: 'Vida útil restante',
          remaining: 'Cantidad restante',
          storageLocation: 'Ubicación de almacenamiento',
          status: 'Estado',
          actions: 'Acciones',
        },
      },
      batchDialog: {
        title: 'Añadir lote',
        description: 'Entrada de mercancías para {{name}}.',
        submit: 'Añadir lote',
        created: 'Lote {{batch}} agregado.',
        error: 'No se pudo crear el lote.',
        fields: {
          batchNumber: 'Número de lote',
          quantity: 'Cantidad ({{unit}})',
          productionDate: 'Fecha de producción',
          bestBeforeDate: 'Fecha de caducidad',
          bestBeforeHint: 'Se sugiere a partir de una vida útil de {{days}} días.',
          storageLocation: 'Ubicación de almacenamiento',
          warehouseCode: 'Almacén',
          supplierBatchNumber: 'Lote del proveedor',
          certificateRef: 'Certificado',
          countryOfOrigin: 'País de origen',
          unitCost: 'Costo unitario',
          referenceType: 'Tipo de referencia',
          notes: 'Notas',
        },
      },
      adjustment: {
        title: 'Ajuste de stock',
        description: '{{name}} · stock actual {{stock}}',
        modeLabel: 'Tipo de asiento',
        modes: {
          DELTA: 'Cantidad de ajuste',
          COUNT: 'Stock contado',
        },
        submit: 'Publicar',
        success: 'Stock ajustado.',
        newStock: 'Nuevo stock: {{value}}',
        error: 'La publicación falló.',
        fields: {
          quantity: 'Cantidad de ajuste',
          quantityHint: 'Los valores positivos añaden stock, los valores negativos lo eliminan.',
          countedQuantity: 'Stock contado',
          countedQuantityHint: 'La diferencia con el stock contable se publica automáticamente.',
          batch: 'Lote',
          warehouseCode: 'Almacén',
          reason: 'Razón',
          reasonHint: 'Obligatorio, al menos {{min}} caracteres (auditable).',
        },
      },
      movements: {
        description: 'Todos los movimientos de stock en orden auditable.',
        empty: 'No se han publicado movimientos aún.',
        error: 'No se pudo cargar el historial de stock.',
        filterType: 'Tipo de movimiento',
        balanceAfter: 'Saldo después: {{value}}',
        entry: '{{date}} · {{user}} · {{reference}}',
      },
      bulkPrice: {
        title: 'Actualizar precios',
        description: 'El cambio se aplica a {{count}} productos seleccionados.',
        submit: 'Actualizar precios',
        success: '{{updated}} productos actualizados, {{skipped}} omitidos.',
        error: 'La actualización de precios falló.',
        targets: {
          LIST_PRICE: 'Precio de venta',
          PURCHASE_PRICE: 'Precio de compra',
        },
        modes: {
          PERCENT: 'Cambiar por porcentaje',
          ABSOLUTE: 'Añadir monto',
          SET: 'Establecer precio fijo',
        },
        valueLabels: {
          PERCENT: 'Cambio en porcentaje',
          ABSOLUTE: 'Cambiar como cantidad',
          SET: 'Nuevo precio',
        },
        fields: {
          target: 'Campo de precio',
          mode: 'Cálculo',
          roundTo: 'Decimales',
          reason: 'Razón',
          reasonHint: 'Almacenado en el registro de auditoría.',
        },
      },
    },
    documents: {
      packaging: {
        baseUnitPriceColumn: 'Precio por pieza / unidad base',
        baseUnitPriceLabel: 'Precio por {{unit}}',
        baseUnitPriceInvalid:
          'Introduzca un precio válido con un máximo de cuatro decimales. El precio del embalaje calculado también debe estar dentro del intervalo permitido.',
        baseUnitPrice: 'Precio por {{unit}}: {{price}}',
        label: 'Unidad / embalaje',
        conversion: '{{quantity}} {{packaging}} = {{baseQuantity}} {{baseUnit}}',
        historic: 'guardado',
        loading: 'Cargando embalajes …',
        loadError: 'No se pudieron cargar los embalajes.',
        pricing: 'Calculando el precio …',
        priceError:
          'Precio sin confirmar. Compruebe la cantidad y el embalaje e inténtelo de nuevo.',
        saveBlocked: 'Cargue los embalajes y complete el cálculo del precio antes de guardar.',
        invalid: 'Introduzca una cantidad válida.',
        minimum: 'La cantidad mínima es {{value}} de la unidad seleccionada.',
        step: 'La cantidad debe ser un múltiplo de {{value}} de la unidad seleccionada.',
      },
      legacyCustomFieldsNotice:
        'No están disponibles las definiciones históricas de los campos personalizados de este documento. No se reinterpretan estos campos. Utilice el documento original.',
      title: 'Documentos',
      subtitle:
        'Cotizaciones, órdenes, albaranes y facturas a lo largo de la cadena de documentos.',
      tabs: {
        all: 'Todos',
      },
      catalog: {
        mode: 'Vista del artículo',
        tab: 'Catálogo',
        positionsTab: 'Artículos',
        customerRequired: 'Por favor, seleccione primero un cliente.',
        selectCustomerHint:
          'Puede navegar por el catálogo. Seleccione un cliente antes de calcular precios vinculantes o agregar un artículo.',
        categories: 'Categorías',
        categoriesDescription: 'Seleccione una categoría para reducir el catálogo.',
        categoriesError: 'No se pudieron cargar las categorías.',
        allProducts: 'Todos los productos',
        expandCategory: 'Expandir {{name}}',
        collapseCategory: 'Colapsar {{name}}',
        breadcrumb: 'Ruta de la categoría',
        search: 'Número de artículo, EAN, nombre, descripción o etiqueta …',
        filters: 'Filtros',
        reset: 'Restablecer filtros',
        activeOnly: 'Solo productos activos',
        availableOnly: 'Solo productos disponibles',
        productType: 'Tipo de producto',
        allTypes: 'Todos los tipos de productos',
        stockStatus: 'Estado de stock',
        allStockStatuses: 'Todos los estados de stock',
        stockStatuses: {
          AVAILABLE: 'Disponible',
          LOW: 'Stock bajo',
          OUT_OF_STOCK: 'No disponible',
          NOT_MANAGED: 'No gestionado por stock',
        },
        manufacturer: 'Fabricante',
        minPrice: 'Precio mínimo',
        maxPrice: 'Precio máximo',
        sort: 'Orden de clasificación',
        sortOptions: {
          name_asc: 'Nombre ascendente',
          name_desc: 'Nombre descendente',
          articleNumber_asc: 'Número de artículo ascendente',
          articleNumber_desc: 'Número de artículo descendente',
          price_asc: 'Precio ascendente',
          price_desc: 'Precio descendente',
          stock_asc: 'Stock ascendente',
          stock_desc: 'Stock descendente',
          lastUsed_desc: 'Usados recientemente',
          updatedAt_desc: 'Actualizados recientemente',
        },
        grid: 'Vista de cuadrícula',
        list: 'Vista de lista',
        loadError: 'No se pudo cargar el catálogo.',
        empty: 'No hay productos que coincidan con esta selección.',
        batch: 'Lote',
        ean: 'EAN',
        available: 'Disponible',
        reserved: 'Reservado',
        notManaged: 'No gestionado por stock',
        customerPrice: 'Precio para el cliente',
        listPrice: 'Precio de lista',
        packaging: 'Unidad de embalaje',
        baseUnit: 'Unidad base ({{unit}})',
        baseQuantity: 'Equivale a {{quantity}} cantidad base {{unit}}',
        quantity: 'Cantidad',
        decrease: 'Disminuir cantidad',
        increase: 'Aumentar cantidad',
        add: 'Agregar',
        addedShort: 'Agregado',
        added: 'Producto agregado al pedido.',
        addError: 'No se pudo agregar el producto.',
        inOrder: 'En pedido: {{quantity}} {{unit}}',
        shortfall: 'La cantidad base solicitada excede el stock disponible.',
      },
      types: {
        QUOTE: 'Cotización',
        ORDER: 'Pedido',
        DELIVERY_NOTE: 'Nota de entrega',
        INVOICE: 'Factura',
        CANCELLATION: 'Factura de cancelación',
        CREDIT_NOTE: 'Nota de crédito',
        PURCHASE_ORDER: 'Orden de compra',
      },
      statuses: {
        DRAFT: 'Borrador',
        SENT: 'Enviado',
        ACCEPTED: 'Aceptado',
        REJECTED: 'Rechazado',
        CONFIRMED: 'Confirmado',
        IN_PROGRESS: 'En progreso',
        PARTIALLY_PROCESSED: 'Procesado parcialmente',
        SHIPPED: 'Enviado',
        COMPLETED: 'Completado',
        POSTED: 'Publicado',
        CANCELLED: 'Cancelado',
      },
      paymentStatuses: {
        OPEN: 'Abierto',
        PARTIALLY_PAID: 'Pagado parcialmente',
        PAID: 'Pagado',
        OVERDUE: 'Vencido',
        WRITTEN_OFF: 'Cancelado',
      },
      taxStrategies: {
        REGULAR: 'Tributación estándar',
        REVERSE_CHARGE: 'Inversión del sujeto pasivo',
        INTRA_COMMUNITY: 'Suministro intracomunitario',
        EXPORT_NON_EU: 'Exportación (fuera de la UE)',
      },
      taxDetermination: {
        title: 'Determinación fiscal explicable',
        loading: 'Comprobando la recomendación fiscal…',
        unavailable: 'La recomendación fiscal no está disponible actualmente',
        selectCustomer:
          'Seleccione un cliente, el modo de entrega y las posiciones para recibir una recomendación.',
        suggestion: 'Recomendación',
        applySuggestion: 'Aplicar recomendación',
        reasonsTitle: 'Motivos de la decisión',
        actionsTitle: 'Comprobaciones y justificantes pendientes',
        noActions: 'No se han detectado comprobaciones pendientes.',
        overrideReason: 'Motivo de la decisión diferente',
        overridePlaceholder: 'Documente el motivo comercial revisado (mínimo 10 caracteres)',
        overrideForbidden: 'Solo los roles autorizados pueden apartarse de la recomendación.',
        disclaimer:
          'Esta recomendación ayuda a revisar el documento, pero no constituye asesoramiento fiscal ni jurídico. Los casos especiales, como operaciones en cadena o triangulares, requieren revisión especializada.',
        deliveryMode: 'Modo de entrega',
        deliveryModes: {
          SHIPMENT: 'Envío',
          PICKUP: 'Recogida',
          UNKNOWN: 'Aún no decidido',
        },
        assessments: {
          ELIGIBLE: 'Requisitos detectados',
          NOT_ELIGIBLE: 'Requisitos no cumplidos',
          REVIEW_REQUIRED: 'Revisión necesaria',
        },
        reasons: {
          CROSS_BORDER_EU_DESTINATION: 'El destino está en otro Estado miembro de la UE.',
          DOMESTIC_DESTINATION: 'El destino está en el país del vendedor.',
          DESTINATION_NOT_EU: 'El destino está fuera de la UE.',
          DESTINATION_MISSING: 'No se ha confirmado el destino real.',
          SELLER_NOT_EU:
            'El vendedor no estaba en un Estado miembro de la UE en la fecha del documento.',
          CUSTOMER_IS_COMPANY: 'El cliente está registrado como empresa.',
          CUSTOMER_NOT_COMPANY: 'El cliente no está registrado como empresa.',
          CUSTOMER_CONFIGURED_EU_B2B: 'El cliente está configurado como B2B de la UE.',
          CUSTOMER_NOT_CONFIGURED_EU_B2B: 'La categoría fiscal del cliente no es B2B de la UE.',
          VAT_ID_VALID_AND_CURRENT: 'El NIF-IVA actual dispone de un justificante VIES vigente.',
          VAT_ID_MISSING: 'El cliente no tiene NIF-IVA.',
          VAT_ID_INVALID: 'La última comprobación del NIF-IVA no fue válida.',
          VAT_ID_COUNTRY_MISMATCH: 'El prefijo del NIF-IVA no coincide con el destino.',
          VAT_VALIDATION_MISSING: 'No hay ninguna comprobación VIES disponible.',
          VAT_VALIDATION_STALE:
            'El justificante VIES está obsoleto o utiliza una asignación anterior.',
          VAT_VALIDATION_UNAVAILABLE:
            'VIES no estaba disponible; esto no cuenta como justificante válido.',
          VAT_ID_CHANGED_SINCE_DOCUMENT_SNAPSHOT:
            'El NIF-IVA ha cambiado desde la instantánea anterior del documento.',
          BILLING_AND_DESTINATION_DIFFER:
            'El país de facturación y el país de destino real son distintos.',
          GOODS_SUPPLY: 'Las posiciones se han identificado como una entrega de bienes.',
          SERVICE_SUPPLY_REVIEW:
            'Los servicios requieren una revisión separada del lugar de prestación y la fiscalidad.',
          MIXED_SUPPLY_REVIEW: 'Se mezclan bienes y servicios y se requiere una revisión separada.',
          SUPPLY_TYPE_UNKNOWN: 'El tipo de prestación aún no está claro.',
          PICKUP_REVIEW:
            'El movimiento transfronterizo necesita justificantes separados en caso de recogida.',
          DELIVERY_MODE_UNKNOWN: 'Aún no se ha decidido el modo de entrega.',
          TRANSPORT_EVIDENCE_AVAILABLE:
            'Hay disponible un justificante de envío o aduana vinculado.',
          TRANSPORT_EVIDENCE_REQUIRED:
            'Aún se requiere un justificante de transporte para la exención.',
          EXISTING_EXPORT_CONFIGURATION:
            'Se ha tenido en cuenta la configuración de exportación del cliente.',
          EXISTING_REVERSE_CHARGE_CONFIGURATION:
            'Se ha tenido en cuenta la configuración de inversión del sujeto pasivo existente.',
          MASTER_FACTS_INCOMPLETE:
            'Faltan datos maestros o de dirección actuales para la evaluación fiscal.',
          SPECIAL_CASE_REVIEW:
            'Este caso no está automatizado y requiere una revisión especializada.',
        },
        actions: {
          VERIFY_VAT_ID: 'Realice una comprobación VIES actual del NIF-IVA.',
          CONFIRM_DESTINATION: 'Confirme el destino real.',
          COLLECT_TRANSPORT_EVIDENCE:
            'Vincule un albarán o un justificante fiable de envío o aduana.',
          REVIEW_SUPPLY_TYPE: 'Revise la clasificación como bien o servicio.',
          REVIEW_PICKUP_OR_SPECIAL_CASE:
            'Solicite la revisión especializada de la recogida o del caso especial.',
          COMPLETE_MASTER_FACTS: 'Revise y complete los datos maestros o de dirección indicados.',
          PROVIDE_OVERRIDE_REASON: 'Explique la decisión fiscal diferente.',
        },
      },
      paymentMethods: {
        INVOICE: 'Factura (pago a cuenta)',
        PREPAYMENT: 'Pago anticipado',
        CASH: 'Efectivo',
      },
      languages: {
        tr: 'Turco',
        es: 'Español',
        de: 'Alemán',
        en: 'Inglés',
        fr: 'Francés',
      },
      languageFallback:
        'No hay una plantilla integrada para este idioma. Se usa alemán si el tenant no aporta una plantilla.',
      columns: {
        number: 'N.° de documento',
        type: 'Tipo',
        customer: 'Cliente',
        documentDate: 'Fecha de documento',
        dueDate: 'Vencimiento',
        status: 'Estado',
        grossTotal: 'Bruto',
      },
      filters: {
        search: 'Buscar documentos',
        searchPlaceholder: 'Número de documento, referencia o cliente …',
        status: 'Estado',
        allStatuses: 'Todos los estados',
        dateFrom: 'Fecha de documento desde',
        dateTo: 'Fecha de documento hasta',
        payment: {
          ALL: 'Todos',
          OPEN: 'Abierto',
          OVERDUE: 'Vencido',
          PAID: 'Pagado',
        },
      },
      actions: {
        create: 'Nuevo documento',
        lock: 'Publicar documento',
        sendEmail: 'Enviar por correo electrónico',
        convertTo: {
          QUOTE: 'Convertir en cotización',
          ORDER: 'Convertir en pedido',
          DELIVERY_NOTE: 'Crear albarán',
          INVOICE: 'Crear factura',
          CANCELLATION: 'Cancelar',
          CREDIT_NOTE: 'Crear nota de crédito',
          PURCHASE_ORDER: 'Crear orden de compra',
        },
      },
      states: {
        empty: 'Aún no hay documentos.',
        pagination: 'Página {{page}} de {{totalPages}} · {{total}} documentos',
      },
      editor: {
        back: 'Volver a la lista',
        newTitle: 'Nuevo documento',
        newSubtitle: 'Seleccione un cliente, agregue líneas de artículos y guarde.',
        type: 'Tipo de documento',
        headSection: 'Encabezado del documento',
        itemsSection: 'Líneas de artículos',
        textsSection: 'Textos',
        customFieldsSection: 'Campos personalizados',
        customFieldsInvalid: 'verificar campo {{count}}',
        customFieldsInvalid_other: 'verificar campos {{count}}',
        addCustomField: 'Añadir campo personalizado',
        addCustomFieldHint: 'Busca un campo de documento o filtra la lista por categoría.',
        removeCustomField: 'Quitar {{field}} del documento',
        searchCustomFields: 'Buscar campos personalizados…',
        customFieldCategory: 'Categoría de campo personalizado',
        allCustomFieldCategories: 'Todas las categorías',
        uncategorizedFields: 'Sin categoría',
        noDocumentCustomFields:
          'No hay campos personalizados configurados para este tipo de documento.',
        noCustomFieldsSelected: 'Todavía no hay campos personalizados opcionales seleccionados.',
        noCustomFieldsAvailable: 'No se encontraron más campos personalizados coincidentes.',
        itemCustomFieldColumns: 'Columnas personalizadas',
        customFieldsToast: 'Error de campo personalizado: {{field}} — {{reason}} [ID: {{id}}]',
        customFieldsMore: 'Un campo más también es inválido.',
        customFieldsMore_other: '{{count}} más campos también son inválidos.',
        customerPlaceholder: 'Buscar cliente …',
        noCustomers: 'No se encontraron clientes.',
        incomplete: 'Por favor proporcione cliente, destinatario y al menos un artículo de línea.',
        created: 'Documento creado.',
        saved: 'Documento guardado.',
        partialQuantities: 'Seleccionar cantidades parciales',
        conversionQuantitiesHint:
          'Sin selección se transfieren todas las cantidades pendientes. Para cantidades parciales, 0 o un campo vacío omite la línea. Las transferencias existentes se comprueban al crear el documento.',
        conversionQuantityInvalid: 'Introduzca al menos una cantidad positiva válida.',
        converted: 'Documento de seguimiento creado.',
        convertFailed: 'Falló la conversión a {{type}}',
        locked: 'Documento contabilizado.',
        customerLockedTitle: '🚨 Cliente bloqueado para ventas',
        customerLockedReason: 'Razón: {{reason}}',
        customerLockedHint:
          'No se puede crear un documento para este cliente. Por favor contacte con contabilidad.',
        customerLockedOverride:
          'Una liberación solo es posible con el método de pago prepago o efectivo.',
        customerLockedSwitchToPrepayment: 'Cambiar a prepago',
      },
      deliveryTerms: {
        replaceManualConfirmation:
          '¿Reemplazar los términos de entrega introducidos manualmente con los predeterminados de la nueva dirección?',
        reset: 'Restablecer por defecto',
        sources: {
          CUSTOMER_DEFAULT: 'Fuente: predeterminado del cliente',
          SHIPPING_ADDRESS: 'Fuente: dirección de envío',
          MANUAL: 'Fuente: anulación manual',
          NONE: 'No se han establecido términos de entrega',
        },
      },
      quoteValidity: {
        automaticHint:
          'Automático: {{days}} días desde la fecha del documento. Puede cambiar o borrar la fecha.',
        manualHint: 'Fecha de validez del presupuesto. Cámbiela o déjela vacía si lo necesita.',
        loading: 'Cargando la validez predeterminada…',
        loadError:
          'No se pudo cargar la validez predeterminada. Inténtelo de nuevo o indique la fecha manualmente.',
      },
      fields: {
        customer: 'Cliente',
        recipient: 'Destinatario',
        documentDate: 'Fecha de documento',
        validUntil: 'Válido hasta',
        reference: 'Su referencia',
        language: 'Idioma del documento',
        currency: 'Moneda',
        taxStrategy: 'Determinación de impuestos',
        paymentMethod: 'Método de pago',
        paymentTermsDays: 'Términos de pago (días)',
        cashDiscountPct: '% de descuento por pronto pago',
        cashDiscountDays: 'Días de descuento por pronto pago',
        discountPct: '% de descuento general',
        shippingAmount: 'Envío',
        shippingAddress: 'Dirección de envío',
        noShippingAddress: 'Sin dirección de envío',
        searchShippingAddress: 'Buscar etiqueta, destinatario o ciudad',
        noMatchingShippingAddress: 'No se encontró ninguna dirección de envío.',
        unnamedShippingAddress: 'Dirección de envío sin datos',
        deliveryTerms: 'Términos de entrega',
        headerText: 'Texto del encabezado',
        footerText: 'Texto del pie de página',
        internalNote: 'Nota interna',
      },
      items: {
        position: 'Artículo',
        article: 'Artículo',
        articlePlaceholder: 'Buscar artículo ...',
        noArticles: 'No se han encontrado artículos.',
        text: 'Texto libre',
        quantity: 'Cantidad',
        unit: 'Unidad',
        unitPrice: 'Precio unitario',
        discount: 'Descuento %',
        taxRate: '% de IVA',
        lineNet: 'Neto',
        remove: 'Quitar línea',
        addArticle: 'Línea del artículo',
        addText: 'Línea de texto',
        batch: 'Lote',
        stock: 'Stock',
        selectBatch: 'Seleccionar lote',
      },
      totals: {
        title: 'Cálculo',
        itemsNet: 'Partidas netas',
        discount: 'Descuento general {{pct}}',
        shipping: 'Envío',
        net: 'Cantidad neta',
        tax: 'IVA {{pct}} en {{base}}',
        gross: 'Cantidad total',
        cashDiscount:
          'Pagar en un plazo de {{days}} días: {{pct}} descuento en efectivo ({{amount}}) – pagaderos {{payable}}.',
      },
      batchPicker: {
        title: 'Selección del lote',
        description: 'Propuesta para "{{product}}" basada en la estrategia de selección elegida.',
        strategy: 'Estrategia',
        bestBefore: 'Fecha de caducidad',
        apply: 'Aplicar',
        empty: 'No se encontró lote disponible.',
        shortfall: 'Escasez de {{quantity}} unidades.',
        levels: {
          EXPIRED: 'Expirado',
          CRITICAL: 'Crítico',
          WARNING: 'Advertencia',
          OK: 'No crítico',
          UNKNOWN: 'Sin fecha de caducidad',
        },
      },
      preview: {
        title: 'Vista previa en PDF',
        refresh: 'Actualizar vista previa',
        download: 'Descargar PDF',
        toggle: 'Alternar vista previa',
        stale: 'La vista previa muestra el último estado guardado.',
      },
      email: {
        title: 'Enviar documento',
        description: 'Enviar documento {{number}} con el PDF adjunto.',
        to: 'Destinatario',
        subject: 'Asunto',
        body: 'Mensaje',
        submit: 'Enviar como vinculante',
        success: 'Documento enviado.',
        failed: 'Error al enviar.',
      },
      delete: {
        title: 'Eliminar documento',
        description: 'El borrador {{number}} será eliminado. Esta acción no se puede deshacer.',
        success: 'Documento eliminado.',
      },
    },
    users: {
      title: 'Gestión de usuarios',
      subtitle: 'Cuentas, roles y estado dentro de este inquilino.',
      create: 'Agregar usuario',
      searchPlaceholder: 'Buscar nombre o correo electrónico',
      error: 'No se pudieron cargar los usuarios.',
      columns: {
        name: 'Nombre',
        email: 'Correo electrónico',
        role: 'Rol',
        status: 'Estado',
        twoFactor: '2FA',
        lastLogin: 'Último inicio de sesión',
      },
      status: {
        active: 'Activo',
        inactive: 'Deshabilitado',
        locked: 'Bloqueado',
      },
      twoFactor: {
        on: 'Habilitado',
        off: 'Deshabilitado',
      },
      filters: {
        role: 'Filtrar por rol',
        allRoles: 'Todos los roles',
      },
      empty: {
        title: 'No se encontraron usuarios',
        description: 'Ajuste la búsqueda o cree una nueva cuenta.',
      },
      actions: {
        label: 'Acciones',
        edit: 'Editar',
        unlock: 'Desbloquear',
        resetPassword: 'Restablecer contraseña',
        resetTwoFactor: 'Restablecer 2FA',
      },
      fields: {
        email: 'Correo electrónico',
        firstName: 'Nombre',
        lastName: 'Apellido',
        phone: 'Teléfono',
        locale: 'Idioma',
        role: 'Rol',
        isActive: 'Cuenta activa',
        selfRoleHint: 'No puede cambiar su propio rol.',
      },
      sheet: {
        createTitle: 'Agregar usuario',
        createDescription: 'La cuenta recibe una contraseña inicial de un solo uso.',
        editTitle: 'Editar usuario',
        editDescription: 'Ajustar datos maestros, rol y estado de la cuenta.',
        passwordHint:
          'La contraseña inicial se muestra una vez después de guardar y debe cambiarse en el primer inicio de sesión.',
      },
      credentials: {
        title: 'Contraseña inicial',
        description: 'Entregar a {{email}} una vez; no se mostrará de nuevo.',
        hint: 'La cuenta debe cambiar esta contraseña en el primer inicio de sesión.',
      },
      toast: {
        created: 'Usuario creado.',
        updated: 'Usuario guardado.',
        unlocked: 'Cuenta desbloqueada.',
        twoFactorReset: 'Autenticación de dos factores restablecida.',
      },
    },
    roles: {
      title: 'Roles y permisos',
      subtitle:
        'Matriz de permisos por rol; los cambios se aplican en el próximo inicio de sesión.',
      list: 'Roles',
      create: 'Agregar rol',
      error: 'No se pudieron cargar los roles.',
      ownerHint: 'El rol de propietario siempre tiene todos los permisos y no puede ser editado.',
      permissionCount: 'Permisos de {{count}} seleccionados',
      fields: {
        name: 'Nombre',
        description: 'Descripción',
      },
      matrix: {
        resource: 'Área',
        toggleRow: 'Todos los permisos para {{resource}}',
      },
      resources: {
        FEATURES: 'Funciones y módulos',
        CUSTOMERS: 'Clientes',
        PARTNER_RISK: 'Riesgo de cliente y bloqueos',
        PRODUCTS: 'Productos',
        BATCHES: 'Lotes y stock',
        DOCUMENTS: 'Documentos',
        DOCUMENT_CUSTOMER_HEADERS: 'Datos del cliente en cabeceras',
        DMS: 'Gestión de documentos',
        ACCOUNTING: 'Contabilidad',
        ANALYTICS: 'Informes',
        EMPLOYEE_PERFORMANCE: 'Rendimiento del empleado',
        SETTINGS: 'Configuración',
        USERS: 'Usuarios',
        TELEPHONY: 'Telefonía e IA',
        ANALYSIS: 'Perfiles de análisis y nutrición',
        MANUFACTURING: 'Producción',
        TRACEABILITY: 'Trazabilidad de lotes',
        MRP: 'Planificación de materiales',
        LABEL_MANAGEMENT: 'Gestión de etiquetas',
        CUSTOM_FIELDS: 'Campos personalizados dinámicos',
        INTRODUCTION: 'Puesta en marcha',
        SETUP: 'Configuración del tenant',
        BACKUPS: 'Copias de seguridad y restauración',
      },
      actions: {
        CREATE: 'Crear',
        READ: 'Leer',
        UPDATE: 'Actualizar',
        DELETE: 'Eliminar',
        EXPORT: 'Exportar',
        APPROVE: 'Aprobar',
        RELEASE: 'Liberar orden de producción',
        RESERVE: 'Reservar material',
        CONSUME: 'Registrar material',
        COMPLETE: 'Notificar fin de producción',
        SIMULATE: 'Simular retirada',
        BLOCK: 'Bloquear lotes',
        REVIEW: 'Revisar',
        MANAGE: 'Gestionar',
        ARCHIVE: 'Archivar',
        ADMIN: 'Administrar',
        USE: 'Realizar llamadas',
        VIEW: 'Ver',
        SET_LOCK: 'Aplicar bloqueo',
        OVERRIDE_LOCK: 'Liberar bloqueo',
        VIEW_OWN_LOGS: 'Propias llamadas',
        VIEW_ALL_LOGS: 'Todas las llamadas',
        VIEW_AI_SUMMARY: 'Ver análisis de IA',
        EDIT_AI_SUMMARY: 'Editar análisis de IA',
        MANAGE_SETTINGS: 'Gestionar ajustes',
        VIEW_COSTS: 'Ver costes',
        RUN: 'Ejecutar planificación',
        CONFIGURE: 'Configurar',
        CONVERT_PURCHASE: 'Crear borrador de compra',
        CONVERT_PRODUCTION: 'Crear borrador de producción',
        IMPORT: 'Realizar importación masiva',
        ROLLBACK: 'Restaurar versión',
        MANAGE_FIELDS: 'Gestionar campos',
        MANAGE_GROUPS: 'Gestionar categorías',
        READ_CONFIDENTIAL: 'Leer campos confidenciales',
        WRITE_CONFIDENTIAL: 'Editar campos confidenciales',
        VIEW_AUDIT: 'Ver historial de cambios',
        CREATE_SETTINGS: 'Crear copia de configuración',
        CREATE_MASTER_DATA: 'Crear copia de datos maestros',
        CREATE_FULL: 'Crear copia completa',
        DOWNLOAD: 'Descargar copia de seguridad',
        RESTORE: 'Restaurar copia de seguridad',
        RESTORE_DRY_RUN: 'Simular restauración',
        VIEW_DEPLOYMENT: 'Ver copias de despliegue',
        DELETE_DETAILS: 'Eliminar detalles de clientes',
        EDIT_PRICES: 'Modificar precios y descuentos',
        CANCEL: 'Anular documentos',
      },
      delete: {
        title: 'Eliminar rol',
        description: 'El rol “{{name}}” será eliminado permanentemente.',
      },
      toast: {
        created: 'Rol creado.',
        updated: 'Rol guardado.',
        deleted: 'Rol eliminado.',
      },
    },
    profile: {
      title: 'Mi perfil',
      subtitle: 'Detalles personales y preferencia de idioma.',
      account: 'Cuenta',
      emailChangeHint:
        'Cambiar tu correo electrónico requiere tu contraseña actual y desactiva el 2FA del correo hasta que se confirme la nueva dirección.',
      role: 'Rol',
      tenant: 'Inquilino',
      saved: 'Perfil guardado.',
    },
    security: {
      title: 'Seguridad',
      subtitle: 'Contraseña, segundo factor y sesiones activas.',
      password: {
        title: 'Cambiar contraseña',
        description: 'Al menos 12 caracteres con mayúsculas y minúsculas, un dígito y un símbolo.',
        current: 'Contraseña actual',
        new: 'Nueva contraseña',
        confirm: 'Confirmar nueva contraseña',
        mismatch: 'Las contraseñas no coinciden.',
        submit: 'Cambiar contraseña',
        changed: 'Contraseña cambiada.',
        show: 'Mostrar contraseña',
        hide: 'Ocultar contraseña',
        strengthLabel: 'Fortaleza de la contraseña',
        strength: {
          '0': 'Muy débil',
          '1': 'Débil',
          '2': 'Regular',
          '3': 'Fuerte',
          '4': 'Muy fuerte',
        },
        rules: {
          length: 'Al menos 12 caracteres',
          uppercase: 'Una letra mayúscula',
          lowercase: 'Una letra minúscula',
          digit: 'Un dígito',
          special: 'Un símbolo',
        },
      },
      forceChange: {
        title: 'Se requiere cambio de contraseña',
        description:
          'Su cuenta fue creada con una contraseña inicial. Por favor, elija ahora su propia contraseña.',
      },
      twoFactor: {
        title: 'Autenticación de dos factores',
        description: 'Protección adicional mediante una aplicación de autenticación (TOTP).',
        active: 'Habilitado',
        inactive: 'Deshabilitado',
        enable: 'Activar',
        disable: 'Desactivar',
        enableTitle: 'Configurar la autenticación de dos factores',
        disableTitle: 'Desactivar la autenticación de dos factores',
        disableDescription: 'Se requieren su contraseña y un código actual para confirmar.',
        intro:
          'Necesita una aplicación de autenticación como 1Password, Aegis o Google Authenticator.',
        start: 'Iniciar configuración',
        steps: {
          scan: 'Paso 1 de 3: iniciar la configuración.',
          verify: 'Paso 2 de 3: escanear el código QR e ingresar el código.',
          codes: 'Paso 3 de 3: guardar los códigos de respaldo.',
        },
        qrAlt: 'Código QR para configurar la aplicación de autenticación',
        enterCode: 'Ingresa el código desde la aplicación',
        code: 'Código de verificación',
        backupHint:
          'Estos códigos reemplazan el segundo factor si pierdes tu dispositivo. Cada código funciona una vez.',
        downloadCodes: 'Descargar códigos de respaldo',
        enabled: 'Autenticación de dos factores habilitada.',
        disabled: 'Autenticación de dos factores deshabilitada.',
        authenticator: 'Aplicación de autenticación (TOTP)',
        makePrimary: 'Hacer principal',
      },
      emailTwoFactor: {
        title: 'Habilitar código de correo electrónico',
        disableTitle: 'Deshabilitar código de correo electrónico',
        method: 'Código de correo electrónico',
        description: 'Confirma tu contraseña, luego ingresa el código del correo electrónico.',
        disableDescription:
          'Ingresa tu contraseña y un código actual de la aplicación de autenticación o de respaldo.',
        secondFactor: 'Autenticador o código de respaldo',
        sentTo: 'Se envió un código de seguridad a {{email}}.',
        send: 'Enviar código',
        confirm: 'Activar',
        enabled: '2FA por correo electrónico activado.',
        disabled: '2FA por correo electrónico desactivado.',
        independenceWarning:
          'Una aplicación de autenticación suele ser más independiente y segura que el correo electrónico, especialmente cuando ambas cuentas se usan en el mismo dispositivo.',
      },
      twoFactorPolicy: {
        title: 'Política 2FA del inquilino',
        description: 'Controla los métodos permitidos y los requisitos para este inquilino.',
        error: 'No se pudo cargar la política de seguridad.',
        methods: {
          TOTP: 'Permitir aplicación de autenticación',
          EMAIL: 'Permitir código de correo electrónico',
        },
        required: 'Requerir autenticación de dos factores para todos los usuarios',
        emailEnabled: 'Habilitar 2FA por correo electrónico para este inquilino',
        privilegedTotp: 'Requerir TOTP para roles privilegiados',
        requiredRoles: 'Roles que requieren 2FA',
        roles: { OWNER: 'Propietario', ADMIN: 'Administrador' },
        validity: 'Validez del código de correo electrónico (minutos)',
        cooldown: 'Reenviar tiempo de espera (segundos)',
      },
      sessions: {
        title: 'Sesiones activas',
        description: 'Dispositivos actualmente conectados con esta cuenta.',
        empty: 'No hay sesiones activas.',
        error: 'No se pudieron cargar las sesiones.',
        current: 'Esta sesión',
        unknownDevice: 'Dispositivo desconocido',
        revoke: 'Revocar',
        revokeOthers: 'Revocar todas las demás sesiones',
        revoked: 'Sesión revocada.',
        revokedOthers: 'Todas las demás sesiones fueron revocadas.',
      },
    },
    securityLog: {
      title: 'Registro de seguridad',
      subtitle: 'Inicios de sesión, cambios de permisos y eventos relevantes de seguridad.',
      searchPlaceholder: 'Buscar correo electrónico o dirección IP',
      filterEvent: 'Filtrar evento',
      allEvents: 'Todos los eventos',
      empty: 'No hay entradas para los filtros seleccionados.',
      error: 'No se pudo cargar el registro.',
      columns: {
        timestamp: 'Marca de tiempo',
        event: 'Evento',
        user: 'Usuario',
        ip: 'Dirección IP',
      },
      events: {
        LOGIN_SUCCESS: 'Inicio de sesión exitoso',
        LOGIN_FAILED: 'Error en el inicio de sesión',
        LOGOUT: 'Cierre de sesión',
        TWO_FACTOR_ENABLED: '2FA activado',
        TWO_FACTOR_DISABLED: '2FA desactivado',
        TWO_FACTOR_FAILED: '2FA fallida',
        TWO_FACTOR_METHOD_CHANGED: 'Método de 2FA cambiado',
        TWO_FACTOR_RESET: '2FA restablecido',
        EMAIL_CHANGED: 'Dirección de correo electrónico cambiada',
        PASSWORD_CHANGED: 'Contraseña cambiada',
        PASSWORD_RESET: 'Contraseña restablecida',
        ACCOUNT_LOCKED: 'Cuenta bloqueada',
        ACCOUNT_UNLOCKED: 'Cuenta desbloqueada',
        ROLE_UPDATED: 'Rol cambiado',
        PERMISSIONS_MODIFIED: 'Permisos cambiados',
        SESSION_REVOKED: 'Sesión revocada',
        USER_CREATED: 'Usuario creado',
        USER_UPDATED: 'Usuario actualizado',
      },
    },
    notifications: {
      title: 'Notificaciones',
      bell: 'Abrir notificaciones',
      bellWithCount: '{{count}} notificaciones no leídas',
      unread: 'No leído',
      open: 'Abierto',
      markAllRead: 'Marcar todo como leído',
      manage: 'Administrar notificaciones',
      error: 'No se pudieron cargar las notificaciones.',
      tabs: {
        all: 'Todos',
        unread: 'No leído',
        critical: 'Crítico',
      },
      empty: {
        title: 'Sin notificaciones',
        description: 'Los nuevos eventos aparecen aquí en tiempo real.',
      },
      categories: {
        STOCK_LOW: 'Nivel de reorden',
        BATCH_EXPIRING: 'Advertencia de vencimiento',
        ORDER_CREATED: 'Nuevo pedido',
        INVOICE_OVERDUE: 'Factura vencida',
        TASK_ASSIGNED: 'Seguimiento',
        SYSTEM: 'Sistema',
      },
    },
    notificationSettings: {
      title: 'Notificaciones',
      subtitle: 'Decida qué eventos le llegan y dónde.',
      matrixTitle: 'Canales de entrega',
      matrixDescription:
        'La campana informa eventos instantáneamente dentro de la aplicación, el correo electrónico también le llega a otros lugares.',
      error: 'No se pudieron cargar los ajustes.',
      autoSave: 'Los cambios se guardan inmediatamente.',
      saved: 'Ajuste guardado.',
      columns: {
        event: 'Evento',
        inApp: 'Campana en la aplicación',
        email: 'Correo electrónico instantáneo',
      },
      descriptions: {
        STOCK_LOW: 'El stock de un artículo alcanza el nivel de reorden.',
        BATCH_EXPIRING: 'Un lote vence dentro de los próximos 30 días.',
        ORDER_CREATED: 'Ha llegado o se ha confirmado un nuevo pedido.',
        INVOICE_OVERDUE: 'Una factura está abierta más allá de su fecha de vencimiento.',
        TASK_ASSIGNED: 'Se le asignó una nota de llamada con seguimiento.',
        SYSTEM: 'Eventos de seguridad y del sistema de este arrendatario.',
      },
    },
    company: {
      title: 'Empresa',
      subtitle: 'Datos maestros, detalles bancarios y valores predeterminados de documentos.',
      error: 'No se pudieron cargar los datos de la empresa.',
      saved: 'Datos de la empresa guardados.',
      invalid: 'Por favor, revise los campos resaltados.',
      sections: {
        identity: 'Empresa',
        identityHint: 'Estos detalles aparecen en el encabezado y pie de página del documento.',
        tax: 'Impuestos y banca',
        taxHint: 'Detalles obligatorios según § 14 UStG más la cuenta bancaria para facturas.',
        layout: 'Diseño de documento',
        layoutHint: 'El logotipo y el color de acento aparecen en cada PDF generado.',
        documents: 'Valores predeterminados del documento',
        documentsHint: 'Configuraciones predefinidas para nuevos presupuestos y facturas.',
      },
      fields: {
        companyName: 'Nombre de la empresa',
        legalForm: 'Forma legal',
        ownerName: 'Propietario / director gerente',
        street: 'Calle y número',
        zip: 'Ciudad',
        city: 'Ciudad',
        country: 'País',
        phone: 'Teléfono',
        email: 'Correo electrónico',
        website: 'ID de IVA',
        vatId: 'ID de IVA',
        taxNumber: 'Registro comercial',
        commercialRegister: 'Registro mercantil',
        commercialRegisterHint: 'p. ej., HRB 12345, Amtsgericht Stuttgart',
        bankName: 'Banco',
        iban: 'IBAN',
        bic: 'BIC',
        primaryColor: 'Color principal',
        invoiceDueDays: 'Plazo de pago en días',
        quoteValidityDays: 'Validez del presupuesto en días',
        defaultEmailSender: 'Dirección del remitente para documentos',
        defaultEmailSenderHint: 'Se utiliza como dirección de respuesta al enviar documentos.',
      },
      legalForms: {
        EINZELUNTERNEHMEN: 'Propietario único',
        FREIBERUFLER: 'Profesional independiente',
        EK: 'e. K.',
        GBR: 'GbR',
        OHG: 'OHG',
        KG: 'KG',
        GMBH: 'GmbH',
        GMBH_CO_KG: 'GmbH & Co. KG',
        UG: 'UG (responsabilidad limitada)',
        AG: 'AG',
        SE: 'SE',
        EG: 'eG',
        LTD: 'Ltd.',
        GESMBH: 'GesmbH (Austria)',
        AG_CH: 'AG (Suiza)',
        SONSTIGE: 'Otros',
      },
      logo: {
        empty: 'Sin logotipo',
        preview: 'Vista previa del logotipo',
        select: 'Elegir logotipo',
        remove: 'Eliminar logotipo',
        hint: 'PNG, JPEG o SVG hasta {{size}} KB.',
        invalidType: 'Los formatos permitidos son PNG, JPEG y SVG.',
        tooLarge: 'El archivo excede {{size}} KB.',
      },
      color: {
        custom: 'Elegir un color personalizado',
        previewTitle: 'Factura RE-2026-00001',
        previewHint: 'Encabezado del documento y reglas de tabla',
      },
    },
    accounting: {
      periods: {
        lastMonth: 'Mes pasado',
        currentMonth: 'Mes actual',
        q1: 'T1',
        q2: 'T2',
        q3: 'T3',
        q4: 'T4',
        currentYear: 'Año actual',
        custom: 'Rango personalizado',
        from: 'Desde',
        to: 'Hasta',
      },
      months: {
        '1': 'Enero',
        '2': 'Febrero',
        '3': 'Marzo',
        '4': 'Abril',
        '5': 'Mayo',
        '6': 'Junio',
        '7': 'Julio',
        '8': 'Agosto',
        '9': 'Septiembre',
        '10': 'Octubre',
        '11': 'noviembre',
        '12': 'diciembre',
      },
      federalStates: {
        '01': 'Schleswig-Holstein',
        '02': 'Hamburgo',
        '03': 'Baja Sajonia',
        '04': 'Bremen',
        '05': 'Renania del Norte-Westfalia',
        '06': 'Hesse',
        '07': 'Renania-Palatinado',
        '08': 'Baden-Wurtemberg',
        '09': 'Baviera',
        '10': 'Sarre',
        '11': 'Berlín',
        '12': 'Brandeburgo',
        '13': 'Mecklemburgo-Pomerania Occidental',
        '14': 'Sajonia',
        '15': 'Sajonia-Anhalt',
        '16': 'Turingia',
      },
      natureOfTransaction: {
        '11': 'Compra/venta directa',
        '12': 'Mercancías en aprobación o prueba',
        '21': 'Devolución de mercancías',
        '22': 'Reemplazo de mercancías devueltas',
        '23': 'Reemplazo de mercancías no devueltas',
        '31': 'Entrega bajo programas de ayuda',
        '41': 'Procesamiento, devolución esperada',
        '51': 'Devolución después del procesamiento',
        '91': 'Alquiler, préstamo o arrendamiento por más de 24 meses',
        '99': 'Otras transacciones',
      },
      modeOfTransport: {
        '1': 'Transporte marítimo',
        '2': 'Transporte ferroviario',
        '3': 'Transporte por carretera',
        '4': 'Transporte aéreo',
        '5': 'Envío postal',
        '7': 'Instalaciones de transporte fijas',
        '8': 'Vía navegable interior',
        '9': 'Propulsión propia',
      },
      datev: {
        title: 'Exportación DATEV',
        subtitle: 'Lote de reservación EXTF para entrega al asesor fiscal.',
        openSettings: 'Configuración',
        periodSection: 'Selección de período y documento',
        reconciliation: 'Reconciliación: debe {{debit}} · haber {{credit}}',
        tabs: {
          export: 'Exportar',
          history: 'Historial de exportación',
        },
        filters: {
          includeCancellations: 'Incluir facturas de cancelación y notas de crédito',
          includeAlreadyExported: 'Incluir documentos ya exportados (ejecución repetida)',
        },
        kpi: {
          records: 'Registros de reserva',
          documents: 'Documentos',
          net: 'Volumen neto',
          gross: 'Volumen bruto',
        },
        columns: {
          date: 'Fecha de documento',
          number: 'N.° de documento',
          customer: 'Cliente',
          account: 'Cuenta',
          contraAccount: 'Cuenta contraria',
          buKey: 'Clave fiscal',
          net: 'Neto',
          tax: 'IVA',
          gross: 'Bruto',
          debitCredit: 'D/C',
          state: 'Estado',
        },
        state: {
          locked: 'Publicado',
          open: 'Abierto',
        },
        states: {
          empty: 'No hay documentos exportables en el período seleccionado.',
        },
        validation: {
          clean: 'Todos los documentos del período están listos para exportar.',
          invalidRange: 'La fecha de inicio no debe ser posterior a la fecha de finalización.',
          openCustomer: 'Cliente abierto',
          openDocument: 'Documento abierto {{number}}',
        },
        issues: {
          DEBTOR_ACCOUNT_MISSING_one: 'Documento {{count}} sin cuenta deudora.',
          DEBTOR_ACCOUNT_MISSING_other: 'Documentos {{count}} sin cuenta deudora.',
          REVENUE_ACCOUNT_MISSING_one: 'Documento {{count}} sin cuenta de ingresos asignada.',
          REVENUE_ACCOUNT_MISSING_other: 'Documentos {{count}} sin cuenta de ingresos asignada.',
          VAT_ID_MISSING_one:
            '{{count}} suministro de la UE con tarifa cero sin el ID de IVA del cliente.',
          VAT_ID_MISSING_other:
            '{{count}} suministros de la UE con tarifa cero sin el ID de IVA del cliente.',
          DOCUMENT_NOT_LOCKED_one:
            '{{count}} el documento aún no está registrado y se registrará en la exportación.',
          DOCUMENT_NOT_LOCKED_other:
            '{{count}} los documentos aún no están registrados y se registrarán en la exportación.',
          DOCUMENT_ALREADY_EXPORTED_one: '{{count}} el documento ya ha sido entregado.',
          DOCUMENT_ALREADY_EXPORTED_other: '{{count}} los documentos ya han sido entregados.',
          SETTINGS_INCOMPLETE_one: 'falta el número de consultor y de cliente en la configuración.',
          SETTINGS_INCOMPLETE_other:
            'falta el número de consultor y de cliente en la configuración.',
          AMOUNT_ZERO_one: '{{count}} documento sin ninguna línea que lleve importe.',
          AMOUNT_ZERO_other: '{{count}} documentos sin ninguna línea que lleve importe.',
        },
        export: {
          action: 'lote de reservas de exportación (.csv)',
          success: 'lote de reservas creado y descargado.',
        },
        history: {
          exportedAt: 'exportado en',
          period: 'período',
          filename: 'archivo',
          records: 'registros / documentos',
          volume: 'Volumen bruto',
          checksum: 'Suma de verificación',
          download: 'Descargar de nuevo',
          repeat: 'Repetir',
          empty: 'Aún no se ha exportado ningún lote de reservas.',
          hint: 'La suma de verificación demuestra que el archivo regenerado coincide con la ejecución archivada.',
        },
      },
      settings: {
        title: 'Configuración contable',
        subtitle:
          'Plan de cuentas, datos maestros de DATEV y valores predeterminados de Intrastat.',
        chartSection: 'Plan de cuentas y datos maestros de DATEV',
        mappingSection: 'Cuentas de ingresos por caso fiscal',
        intrastatSection: 'Valores predeterminados de Intrastat',
        saved: 'Configuración guardada.',
        charts: {
          SKR03: 'Basado en procesos; cuentas de ingresos en el rango de 8000–8999.',
          SKR04: 'Basado en balance; cuentas de ingresos en el rango de 4000–4999.',
        },
        fields: {
          consultantNumber: 'Número de consultor',
          clientNumber: 'Número de cliente',
          fiscalYearStart: 'Inicio del año fiscal',
          accountNumberLength: 'Longitud del número de cuenta',
          debtorAccountRangeStart: 'Inicio del rango de deudores',
          dictationKey: 'Tecla de dictado',
          reportingVatId: 'ID de IVA del declarante',
          federalState: 'Estado federal',
          natureOfTransaction: 'Naturaleza predeterminada de la transacción',
          modeOfTransport: 'Modo de transporte predeterminado',
        },
        mapping: {
          case: 'Caso fiscal',
          account: 'Cuenta de ingresos',
          buKey: 'Clave fiscal',
          accountFor: 'Cuenta de ingresos para {{case}}',
          buKeyFor: 'Clave fiscal para {{case}}',
          automatic: 'Automático',
        },
        revenueCases: {
          DOMESTIC_STANDARD: { label: 'Nacional 19 %', hint: 'Tipo estándar en Alemania.' },
          DOMESTIC_REDUCED: { label: 'Nacional 7 %', hint: 'Tipo reducido en Alemania.' },
          DOMESTIC_EXEMPT: { label: 'Nacional exento', hint: 'Facturación interna a tipo cero.' },
          INTRA_COMMUNITY: {
            label: 'UE a tipo cero',
            hint: 'Suministro intracomunitario, art. 4 nº 1b UStG.',
          },
          EXPORT_NON_EU: {
            label: 'Exportación fuera de la UE',
            hint: 'Suministro de exportación, art. 4 nº 1a UStG.',
          },
          REVERSE_CHARGE: {
            label: 'Inversión del sujeto pasivo',
            hint: 'El destinatario debe el IVA, art. 13b UStG.',
          },
        },
        debtors: {
          action: 'Asignar cuentas deudoras',
          assigned_one: '{{count}} cuenta deudora asignada.',
          assigned_other: '{{count}} cuentas deudoras asignadas.',
        },
      },
      intrastat: {
        title: 'Declaración Intrastat',
        subtitle: 'Envíos a otros estados miembros de la UE por mes de referencia.',
        periodSection: 'Periodo de reporte',
        fields: {
          year: 'Año de reporte',
          month: 'Mes de referencia',
          direction: 'Flujo',
        },
        directions: {
          DISPATCH: 'Envío',
          ARRIVAL: 'Llegada',
        },
        kpi: {
          value: 'Importe facturado',
          weight: 'Masa neta',
          positions: 'Artículos declarados',
        },
        columns: {
          commodityCode: 'Código del producto (CN8)',
          destination: 'Destino',
          origin: 'País de origen',
          nature: 'Naturaleza de la transacción',
          transport: 'Modo de transporte',
          weight: 'Masa neta',
          invoiced: 'Importe facturado',
          statistical: 'Valor estadístico',
          partnerVatId: 'ID de IVA del socio',
        },
        issueFields: {
          commodityCode: 'Código de mercancía faltante o no tiene 8 dígitos',
          countryOfOrigin: 'País de origen faltante',
          netWeight: 'Peso neto faltante',
          destinationCountry: 'País de destino faltante',
        },
        readiness: {
          clean: 'Todos los artículos declarables están completos.',
          blocked_one: 'El producto {{count}} bloquea la declaración.',
          blocked_other: 'Los productos {{count}} bloquean la declaración.',
          openProduct: 'Abrir producto',
        },
        states: {
          empty: 'No hay despachos declarables para este mes de referencia.',
        },
        export: {
          csv: 'Lista de control (.csv)',
          xml: 'INSTAT/XML para IDEV',
          success: 'Archivo de declaración creado y descargado.',
        },
      },
    },
  },
} as const;
